module.exports = __webpack_public_path__ + "media/SuiteApp/assets/svg/img/dropdown-d9f01dadb10beab3dbc4c83f52c89571.svg";